module.exports = __webpack_public_path__ + "static/media/Holy Cross Newsletter April 2025.374110b1.pdf";